import { Store } from '@ngrx/store';
import { Component, OnInit, OnDestroy, Renderer2, Inject, ViewChild, ElementRef } from '@angular/core';
import { Subscription, lastValueFrom } from 'rxjs';
import { CartService } from 'src/app/shared/services/cart.service';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/app/shared/services/api.service';
import { Router } from '@angular/router';
import { async } from 'rxjs/internal/scheduler/async';
import { element } from 'protractor';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';


@Component({
	selector: 'shop-cart-page',
	templateUrl: './cart.component.html',
	styleUrls: ['./cart.component.scss']
})

export class CartComponent implements OnInit, OnDestroy {

	cartItems = [];
	SERVER_URL = environment.SERVER_URL;
	pointsFlag = true;
	userPoints:number = -1;	
	new_total:number=0.00;	
	@ViewChild('points2Redeem') points2Redeem: ElementRef;
	total_price:number=0.00;	
	public dtShipping=[];
	
	

	private subscr: Subscription;

	constructor(private store: Store<any>, public cartService: CartService, public apiService:ApiService,
			 public router:Router, private renderer:Renderer2, @Inject(DOCUMENT) private document: Document, private titleService:Title) {
	}

	async ngOnInit() {
		this.subscr = this.cartService.cartStream.subscribe(items => {
			this.cartItems = items;
		});
		this.titleService.setTitle('Checkout');

		//await this.getShippingOptions();
		
		if(typeof window !== 'undefined')
			await this.sortOutShipping();
				
		this.loadJsScript();

		this.apiService.redeemPoints=0;

	}

	ngOnDestroy() {
		this.subscr.unsubscribe();
	}

	trackByFn(index: number, item: any) {
		if (!item) return null;
		return item.slug;
	}

	updateCart(event: any) {
		event.preventDefault();
		event.target.parentElement.querySelector('.icon-refresh').classList.add('load-more-rotating');

		setTimeout(() => {
			this.cartService.updateCart(this.cartItems);
			event.target.parentElement.querySelector('.icon-refresh').classList.remove('load-more-rotating');
			document.querySelector('.btn-cart-update:not(.diabled)') && document.querySelector('.btn-cart-update').classList.add('disabled');						
		}, 400);
		
		//uncheck radio button
		let valueSelected = false;		
		var chx = document.getElementsByTagName('input');
		for (var i=0; i<chx.length; i++) {		  
		  if (chx[i].type == 'radio' && chx[i].checked) {
			chx[i].checked = false;
		  } 
		}	
		//reset reedem points
		this.points2Redeem.nativeElement.value = "";
		this.apiService.redeemPoints=0;
	}

	changeShipping(value: number, desc?:string, id?:string, freeShipping?:number) {
		//this.shippingCost = value;
		//this.apiService.shippingCost = value;
		this.apiService.shippingDesc = desc;
		this.apiService.shippingId = id;
		this.apiService.shippingLimit = freeShipping;		
		//console.log("Shipping : ",this.cartService.priceTotal['_value']);
		if(Number(this.cartService.priceTotal['_value']) >= freeShipping){			
			this.apiService.shippingCost = 0;			
		}
		else{
			this.apiService.shippingCost = value;
		}
	}

	onChangeQty(event: number, product: any) {
		document.querySelector('.btn-cart-update.disabled') && document.querySelector('.btn-cart-update.disabled').classList.remove('disabled');

		this.cartItems = this.cartItems.reduce((acc, cur) => {
			if (cur.name === product.name) {
				acc.push({
					...cur,
					qty: event,
					sum: (cur.sale_price ? cur.sale_price : cur.price) * event
				});
			}
			else acc.push(cur);

			return acc;
		}, [])
	}

	/**
	 * Check if there is at least one radio button checked	 
	 */
	async isOneChecked() {
		let valueSelected = false;
		// All <input> tags...
		var chx = document.getElementsByTagName('input');
		for (var i=0; i<chx.length; i++) {
		  // If you have more than one radio group, also check the name attribute
		  // for the one you want as in && chx[i].name == 'choose'
		  // Return true from the function on first match of a checked item
		  if (chx[i].type == 'radio' && chx[i].checked) {
			valueSelected = true;
		  } 
		}		
		let res = await this.checkStockBeforePay();
		if(res)
			return;

		if(this.check_points()){
			if((valueSelected || this.apiService.dtShipping.length<1)){
				this.router.navigate(['/shop/checkout']);
			}		
			else{
				this.apiService.popupMsg("Select Shipping!","No shipping method selected","info");
			}
		}		
						
	}

	/**
	 * check if the user is abroad and only apply international shipping
	 * else show the rest of the option excep international
	 */
	async sortOutShipping(){		
		await this.getShippingOptions();
		let tmp = this.apiService.dtShipping;				
		if(this.apiService.userInfo.length > 0){
			let country = this.apiService.userInfo[0].CUSTCOUNTRY;
			if(country.length>0){
				if (country === 'Cyprus'){
					//remove international					
					tmp.forEach((element,index)=>{
						if(element.DESCRIPTION.includes('International'))
							tmp.splice(index,1);
					});
					this.dtShipping = tmp;					
				}
				else{
					//remove them all but international			
					let tmp2=[];
					tmp.forEach((element,index)=>{
						if(element.DESCRIPTION.includes('International')){
							tmp2[0] = tmp[index];	
							this.dtShipping = tmp2;														
						}					
					});
				}	
			}
			else{				
				this.apiService.popupMsg(this.apiService.companyName,'Please update your Country info!','error');				
				this.router.navigate(['/shop/dashboard'])
			}
			
		}
		else{
			this.apiService.popupMsg(this.apiService.companyName,'Please login first!','error');
			this.router.navigate(['/'])
		}
		
			
	}

	loadJsScript(){
		const script = this.renderer.createElement('script');
		//script.type = 'text/javascript';
		script.src = "https://www.paypal.com/sdk/js?client-id="+this.apiService.paypal_auth+"&currency=EUR";
		/*
		script.text = `
		{
		  "@context": "https://www.paypal.com/sdk/js?client-id="${this.apiService.paypal_auth}
		  
		}`;
		*/
		this.renderer.appendChild(this.document.head, script);		
		//console.log(script.src);
	  }

	  changeClicked(){
		let redeemedpoints = this.points2Redeem.nativeElement.value;
		this.userPoints =  Number(this.apiService.userInfo[0].CUST_POINT_Balance) - Number(this.apiService.userInfo[0].CUST_POINTS_Onhold);
		if ( Number(redeemedpoints) > Number(this.userPoints)){
			this.pointsFlag=false;
			this.apiService.popupMsg('Redeemed Points','Your total points are '+ this.userPoints.toFixed(2),'info');
		}
		else if(redeemedpoints > Number(this.cartService.priceTotal['_value'])){
			this.pointsFlag=false;
			this.apiService.popupMsg('Redeemed Points','Points exceed Subtotal price','info');
		}
		else {
			this.pointsFlag=true;
			this.apiService.redeemPoints = redeemedpoints;
			//this.new_total = this.total_price - redeemedpoints;			
		}		
	}
	
	/*
	* check redeem points again in case the user ignores the message in changeClicked
	*/
	check_points(){
		//let pointsFlag=false;
		let redeemedpoints =0;
		if(this.apiService.showPoints)
			redeemedpoints = this.points2Redeem.nativeElement.value;
		//console.log(redeemedpoints);
		if(redeemedpoints != 0 && redeemedpoints.toString() != "" && redeemedpoints != undefined){
			if (Number(redeemedpoints) > Number(this.userPoints)){
				this.pointsFlag=false;
				this.apiService.popupMsg('Redeemed Points','Your total points are '+ this.userPoints.toFixed(2),'info');
			}
			else if(redeemedpoints > Number(this.cartService.priceTotal['_value'])){
				this.pointsFlag=false;
				this.apiService.popupMsg('Redeemed Points','Points exceed Subtotal price','info');
			}
			else {
				this.pointsFlag=true;			
			}
		}
		else
			this.pointsFlag=true;
		return this.pointsFlag;
	}
	
	async checkStockBeforePay(){
		/**
		 * check if items are in stock and abort payment if neccessary
		*/			
		for(let i=0; i<this.cartItems.length;i++){
		  let res:any = await lastValueFrom(this.apiService.getSingleProductPromise(this.cartItems[i].id));
		  if(this.cartItems[i].qty > res.product.stock ){										
			this.apiService.popupMsg("Out of Stock!\n"+this.cartItems[i].name,"Available stock: "+res.product.stock,"error");
			return true;						
		  }
		}		
		return false;
	  }

	  async getShippingOptions(){				
		//get shipping options
		let sb:string='';
		sb += " SELECT * ";
		sb += " FROM SHIPPING ";
		sb += " WHERE DELETEDFLAG=0 ";
		if(typeof window !== 'undefined'){
			this.apiService.dtShipping = await lastValueFrom(this.apiService.execSqlQueryNew(sb));										 
		}		
	  }
}